// extracted by mini-css-extract-plugin
module.exports = {"list":"_6094","item":"_6491","cover":"_19972","content":"_6442","title":"_8346","desc":"_5607"};